
import React from 'react';

const TreatmentOptions = () => {
  const treatments = [
    {
      name: 'Energy Boost IV',
      description: 'Combat fatigue and enhance energy levels with our powerful B-vitamin complex and amino acid blend',
      ingredients: ['B-Complex Vitamins', 'B12', 'Amino Acids', 'Magnesium'],
      benefits: ['Increased energy', 'Enhanced focus', 'Reduced fatigue', 'Improved mood'],
      duration: '30-45 minutes',
      price: '$149',
      image: 'https://public.readdy.ai/ai/img_res/3c938d536c0e54d6e57f27f52706a720.jpg'
    },
    {
      name: 'Immune Support IV',
      description: 'Strengthen your immune system with high-dose vitamin C, zinc, and powerful antioxidants',
      ingredients: ['Vitamin C (25g)', 'Zinc', 'Glutathione', 'Selenium'],
      benefits: ['Immune enhancement', 'Antioxidant protection', 'Faster recovery', 'Illness prevention'],
      duration: '45-60 minutes',
      price: '$179',
      image: 'https://readdy.ai/api/search-image?query=Immune%20support%20IV%20therapy%20with%20clear%20vitamin%20C%20solution%2C%20professional%20medical%20clinic%2C%20clean%20white%20background%20with%20blue%20accents%2C%20wellness%20treatment%20room%20setting&width=600&height=400&seq=immune-iv&orientation=landscape'
    },
    {
      name: 'Hydration Plus IV',
      description: 'Rapid rehydration with electrolytes, minerals, and essential vitamins for optimal cellular function',
      ingredients: ['Saline Solution', 'Electrolytes', 'B-Vitamins', 'Magnesium'],
      benefits: ['Rapid hydration', 'Electrolyte balance', 'Hangover relief', 'Athletic recovery'],
      duration: '30-45 minutes',
      price: '$129',
      image: 'https://readdy.ai/api/search-image?query=Hydration%20IV%20therapy%20with%20clear%20saline%20solution%2C%20modern%20medical%20equipment%2C%20clean%20white%20background%20with%20aqua%20blue%20accents%2C%20professional%20hydration%20treatment%20setup&width=600&height=400&seq=hydration-iv&orientation=landscape'
    },
    {
      name: 'Beauty Glow IV',
      description: 'Enhance skin health and radiance with collagen-supporting nutrients and powerful antioxidants',
      ingredients: ['Vitamin C', 'Biotin', 'Glutathione', 'Collagen Peptides'],
      benefits: ['Skin brightening', 'Anti-aging effects', 'Hair & nail health', 'Collagen production'],
      duration: '45-60 minutes',
      price: '$199',
      image: 'https://readdy.ai/api/search-image?query=Beauty%20glow%20IV%20therapy%20with%20golden%20vitamin%20solution%2C%20luxury%20wellness%20spa%20setting%2C%20clean%20white%20background%20with%20rose%20gold%20accents%2C%20professional%20beauty%20treatment%20equipment&width=600&height=400&seq=beauty-iv&orientation=landscape'
    },
    {
      name: 'Athletic Performance IV',
      description: 'Optimize performance and recovery with amino acids, electrolytes, and performance-enhancing nutrients',
      ingredients: ['Amino Acids', 'Electrolytes', 'B-Vitamins', 'Taurine'],
      benefits: ['Enhanced performance', 'Faster recovery', 'Muscle support', 'Endurance boost'],
      duration: '45-60 minutes',
      price: '$189',
      image: 'https://readdy.ai/api/search-image?query=Athletic%20performance%20IV%20therapy%20with%20sports%20medicine%20equipment%2C%20modern%20fitness%20clinic%2C%20clean%20white%20background%20with%20red%20accents%2C%20professional%20sports%20recovery%20treatment&width=600&height=400&seq=athletic-iv&orientation=landscape'
    },
    {
      name: 'Myers Cocktail IV',
      description: 'The classic wellness IV with magnesium, calcium, B-vitamins, and vitamin C for overall health',
      ingredients: ['Magnesium', 'Calcium', 'B-Complex', 'Vitamin C'],
      benefits: ['General wellness', 'Stress relief', 'Energy support', 'Nutrient replenishment'],
      duration: '30-45 minutes',
      price: '$159',
      image: 'https://readdy.ai/api/search-image?query=Myers%20cocktail%20IV%20therapy%20with%20classic%20vitamin%20blend%2C%20professional%20medical%20clinic%2C%20clean%20white%20background%20with%20green%20accents%2C%20traditional%20wellness%20treatment%20setup&width=600&height=400&seq=myers-iv&orientation=landscape'
    },
    {
      name: 'Detox & Cleanse IV',
      description: 'Support your body\'s natural detoxification with glutathione, alpha-lipoic acid, and liver-supporting nutrients',
      ingredients: ['Glutathione', 'Alpha-Lipoic Acid', 'Vitamin C', 'B-Complex'],
      benefits: ['Liver support', 'Toxin elimination', 'Cellular cleansing', 'Antioxidant boost'],
      duration: '60-75 minutes',
      price: '$219',
      image: 'https://readdy.ai/api/search-image?query=Detox%20cleanse%20IV%20therapy%20with%20clear%20antioxidant%20solution%2C%20modern%20wellness%20clinic%2C%20clean%20white%20background%20with%20purple%20accents%2C%20professional%20detoxification%20treatment%20equipment&width=600&height=400&seq=detox-iv&orientation=landscape'
    },
    {
      name: 'Brain Boost IV',
      description: 'Enhance cognitive function and mental clarity with nootropic nutrients and brain-supporting vitamins',
      ingredients: ['NAD+', 'B-Complex', 'Magnesium', 'Phosphatidylcholine'],
      benefits: ['Mental clarity', 'Focus enhancement', 'Memory support', 'Cognitive optimization'],
      duration: '60-90 minutes',
      price: '$249',
      image: 'https://readdy.ai/api/search-image?query=Brain%20boost%20IV%20therapy%20with%20cognitive%20enhancement%20nutrients%2C%20modern%20neurology%20clinic%2C%20clean%20white%20background%20with%20purple%20accents%2C%20professional%20brain%20health%20treatment%20setup&width=600&height=400&seq=brain-iv&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            Comprehensive <strong>IV Therapy</strong> Menu
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Choose from our extensive menu of IV vitamin therapies, each formulated to address specific health goals and optimize your wellness.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {treatments.map((treatment, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="aspect-video overflow-hidden">
                <img 
                  src={treatment.image} 
                  alt={treatment.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              <div className="p-6 lg:p-8">
                <div className="flex justify-between items-start mb-3">
                  <h3 className="text-xl lg:text-2xl font-bold text-gray-900">
                    {treatment.name}
                  </h3>
                  <span className="text-xl lg:text-2xl font-bold text-orange-600">
                    {treatment.price}
                  </span>
                </div>
                <p className="text-gray-600 mb-4 lg:mb-6 leading-relaxed">
                  {treatment.description}
                </p>

                <div className="grid grid-cols-2 gap-4 mb-4 lg:mb-6">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Key Ingredients:</h4>
                    <div className="space-y-1">
                      {treatment.ingredients.map((ingredient, idx) => (
                        <div key={idx} className="text-sm text-gray-600">{ingredient}</div>
                      ))}
                    </div>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Duration:</h4>
                    <div className="text-sm text-gray-600 mb-3">{treatment.duration}</div>
                  </div>
                </div>

                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3">Benefits:</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {treatment.benefits.map((benefit, idx) => (
                      <div key={idx} className="flex items-center">
                        <i className="ri-check-line text-orange-600 text-sm mr-2"></i>
                        <span className="text-gray-700 text-sm">{benefit}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <button className="w-full bg-gradient-to-r from-orange-600 to-orange-700 text-white py-3 px-6 rounded-xl font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer">
                  Book {treatment.name}
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 lg:mt-16">
          <div className="bg-orange-50 rounded-2xl p-6 lg:p-8 max-w-4xl mx-auto">
            <h3 className="text-xl lg:text-2xl font-bold text-gray-900 mb-4">
              Custom IV Formulations Available
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Our medical team can create personalized IV formulations tailored to your specific health needs, goals, and biomarker results.
            </p>
            <button className="bg-gradient-to-r from-orange-600 to-orange-700 text-white px-8 py-4 rounded-xl font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Request Custom Formulation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TreatmentOptions;
